import React, { useState, useEffect } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  IconButton
} from '@mui/material';
import { MdDelete } from "react-icons/md";
import axios from "axios";
const BE_URI = process.env.REACT_APP_BE_URI;

const EditWifiModuleModal = ({
  modalVisible,
  setModalVisible,
  selectedWifiModule,
  token,
  wifiModules,
  setWifiModules,
  getWifiModules,
  buttonColor
}) => {
  const [name, setName] = useState(selectedWifiModule?.name ?? '');

  useEffect(() => {
    setName(selectedWifiModule?.name ?? '');
  }, [selectedWifiModule]);

  const handleUpdateWifiModule = async () => {
    try {
      const formData = {
        wifiModule: {
          _id: selectedWifiModule._id,
          name: name,
        },
      };
      const res = await axios.put(BE_URI + '/update-wifiModule', formData, {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          authorization: `Bearer ${token}`,
        },
      });

      if (res.data.success) {
        const updatedModules = wifiModules.filter(wf => wf._id !== selectedWifiModule._id);
        setWifiModules([...updatedModules, res.data.wifiModule].sort((a, b) => a.sequence - b.sequence));
        getWifiModules(); // Optional refresh logic
      }
      setModalVisible(false);
    } catch (error) {
      console.error('Error:', error);
      setModalVisible(false);
    }
  };

  const handleDeleteWifiModule = async () => {
    try {
      const res = await axios.post(BE_URI + '/delete-wifiModule', { id: selectedWifiModule._id }, {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          authorization: `Bearer ${token}`,
        },
      });

      if (res.data.success) {
        setWifiModules(res.data.wifiModules);
      }
      setModalVisible(false);
    } catch (error) {
      console.error('Error:', error);
      setModalVisible(false);
    }
  };

  const isModified = name !== selectedWifiModule?.name;

  return (
    <Dialog open={modalVisible} onClose={() => setModalVisible(false)}>
      <DialogTitle style={{ backgroundColor: buttonColor, color: '#FFFFFF', textAlign: 'center' }}>
        Edit Wifi Module
      </DialogTitle>
      <DialogContent>
        <TextField
          fullWidth
          label="Name"
          variant="outlined"
          value={name}
          onChange={(e) => setName(e.target.value)}
          margin="dense"
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={() => setModalVisible(false)} style={{ color: buttonColor }}>Cancel</Button>
        <Button onClick={isModified ? handleUpdateWifiModule : () => setModalVisible(false)} style={{ color: buttonColor }}>
          {isModified ? 'Save' : 'OK'}
        </Button>
        <IconButton onClick={handleDeleteWifiModule} style={{ color: buttonColor }}>
            <MdDelete />
        </IconButton>
      </DialogActions>
    </Dialog>
  );
};

export default EditWifiModuleModal;